/* eslint-disable @atlaskit/design-system/ensure-design-token-usage -- Brand asset colors are intentionally static and not sourced from theme tokens. */
import React from 'react';

const COLORS = {
	light: {
		blue: '#357DE8',
		green: '#82B536',
		purple: '#BF63F3',
		yellow: '#FCA700',
	},
	dark: {
		blue: '#1868DB',
		green: '#6A9A23',
		purple: '#AF59E0',
		yellow: '#FCA700',
	},
} as const;

type RovoColorLogoProps = {
	colorMode: 'light' | 'dark';
};

export const RovoColorLogo = ({ colorMode }: RovoColorLogoProps): React.JSX.Element => {
	const colors = COLORS[colorMode] ?? COLORS.light;

	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2961 15.6713L4.10278 19.8244L2.66999 18.9977C1.82857 18.5126 1.30786 17.6127 1.30786 16.6431V7.36597C1.30786 6.39257 1.82552 5.49654 2.66944 5.01169L8.71294 1.5249C8.69954 1.56253 8.68676 1.60042 8.67462 1.63854C8.56274 1.9857 8.50344 2.35249 8.50344 2.7274V12.0045C8.50344 13.2789 9.18226 14.4544 10.2885 15.0902L11.2961 15.6713Z"
				fill={colors.blue}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2961 15.6714L4.10278 19.8244L10.7097 23.6363C11.5361 24.1127 12.553 24.1212 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.2871 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7932 21.5652 14.7932 21.2817V17.6881L11.2961 15.6714Z"
				fill={colors.green}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.4773 5.0024L19.9362 4.11328L12.7429 8.26635L13.8592 8.9101C14.9656 9.54588 15.644 10.7212 15.644 11.9956V21.2728C15.644 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4345 22.4753L21.478 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35706C22.8395 6.3875 22.3187 5.4875 21.4773 5.0024Z"
				fill={colors.purple}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.7406 8.26623L9.35181 6.31195V2.71837C9.35181 2.43521 9.39561 2.15859 9.47851 1.89674C9.68231 1.26299 10.1158 0.714353 10.7088 0.371866L10.7106 0.370829C10.7276 0.361021 10.7438 0.350143 10.7588 0.338447C11.592 -0.121106 12.6089 -0.112663 13.4353 0.363774L19.9339 4.11316L12.7406 8.26623Z"
				fill={colors.yellow}
			/>
		</svg>
	);
};
